import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography, Paper, Chip } from '@mui/material';
import { Cable as CableIcon, Input as InputIcon } from '@mui/icons-material';

interface InputNodeData {
  id: number;
  label: string;
  tipo: string;
  color: string;
  fibras?: number;
  cabo_nome?: string;
}

const InputNode: React.FC<NodeProps<InputNodeData>> = ({ data, selected }) => {
  const handleColor = data.color || '#4CAF50';
  
  return (
    <Paper
      elevation={selected ? 8 : 3}
      sx={{
        minWidth: 120,
        minHeight: 60,
        border: selected ? `2px solid ${handleColor}` : '1px solid #ddd',
        borderRadius: 2,
        backgroundColor: '#fff',
        transition: 'all 0.2s ease',
        position: 'relative',
        '&:hover': {
          elevation: 6,
          transform: 'scale(1.02)'
        }
      }}
    >
      {/* Handle de saída (direita) */}
      <Handle
        type="source"
        position={Position.Right}
        id="output"
        style={{
          background: handleColor,
          border: '2px solid #fff',
          width: 12,
          height: 12,
          right: -6
        }}
      />
      
      {/* Conteúdo do nó */}
      <Box
        sx={{
          p: 1.5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5
        }}
      >
        {/* Ícone e tipo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <InputIcon sx={{ fontSize: 18, color: handleColor }} />
          <Chip
            label="ENTRADA"
            size="small"
            sx={{
              backgroundColor: handleColor,
              color: 'white',
              fontSize: '0.65rem',
              height: 18
            }}
          />
        </Box>
        
        {/* Label */}
        <Typography
          variant="caption"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '0.75rem',
            color: '#333',
            lineHeight: 1.2
          }}
        >
          {data.label}
        </Typography>
        
        {/* Informações adicionais */}
        {data.fibras && (
          <Typography
            variant="caption"
            sx={{
              fontSize: '0.65rem',
              color: '#666',
              textAlign: 'center'
            }}
          >
            {data.fibras} fibras
          </Typography>
        )}
        
        {data.cabo_nome && (
          <Typography
            variant="caption"
            sx={{
              fontSize: '0.6rem',
              color: '#999',
              textAlign: 'center',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {data.cabo_nome}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default memo(InputNode); 